
export const 音標服務 = "https://hts.ithuan.tw/羅馬字轉換"
// export const 音標服務 = "http://localhost:8000/羅馬字轉換"



// WEBPACK FOOTER //
// ./src/後端網址.js